import React from "react";
import { ITotallingManagement } from "../../../models/response/ITotallingManagementResponse";
import { FormattedMessage } from "react-intl";
import { showAmountWithFormatting } from "../../../helpers/common-component-helper";

interface TotallingProps {
  data: ITotallingManagement;
}

const DailyTotallingTable: React.FC<TotallingProps> = ({ data }) => {
  const totalRows =
    data.treatments.length +
    data.options.length +
    data.products.length +
    4; // treatment total + products header + product total + grand total

  const paymentKeys = Object.keys(data.payments);

  return (
    <div className="table-responsive treatment-detail-table">
    <table className="table table-bordered table-sm text-center align-middle" >
      <thead>
        
        <tr className="table-primary text-white bg-primary">
          <th><FormattedMessage id="treatment" /></th>
          <th><FormattedMessage id="category" /></th>
          <th><FormattedMessage id="sales_number_of_treatments" /></th>
          {paymentKeys.map(pm => (
            <th key={pm}>{pm}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {/* Treatments */}
        {data.treatments.map((t, idx) => (
          <tr key={idx}>
            <td>{t.name}</td>
            <td className="gray-col">{t.categoryName}</td>
            <td className="white-col">
              {showAmountWithFormatting(t.amount)} ({t.percentage}) / {t.repetitions}
            </td>

            {/* Render payments only on first row, rowspan covers all */}
            {idx === 0 &&
              paymentKeys.map(pm => (
                <td
                  key={pm}
                  rowSpan={totalRows}
                  className="align-middle gray-col text-center "
                >
                  {showAmountWithFormatting(data.payments[pm])}
                </td>
              ))}
          </tr>
        ))}

        {/* Options */}
        {data.options.map((o, idx) => (
          <tr key={`opt-${idx}`}>
            <td>{o.name}
              <span className="badge bg-primary rounded ms-2">
                <FormattedMessage id="option" />
              </span>
            </td>
            <td></td>
            <td>
              {showAmountWithFormatting(o.amount)} ({o.percentage}) / {o.repetitions}
            </td>
          </tr>
        ))}

        {/* Treatment total */}
        <tr className="fw-bold table-secondary">
          <td className="gray-col"><FormattedMessage id="total_treatment_cost"/></td>
          <td></td>
          <td className="gray-col">{showAmountWithFormatting(data.treatmentTotal)}</td>
            {data.treatments.length === 0  && paymentKeys.map((pm) => (
              <td
                key={pm}
                rowSpan={totalRows}
                className="align-middle text-center"
              >
                {showAmountWithFormatting(data.payments[pm])}
              </td>
              )
            )}
        </tr>

        {/* Products header */}
        <tr className="table-primary text-white bg-primary">
            <th className="blue-col"><FormattedMessage id="merchandise" /></th>
          <th className="blue-col"><FormattedMessage id="category" /></th>
          <th className="blue-col"><FormattedMessage id="sales_number_of_products" /></th>
        </tr>

        {/* Products */}
        {data.products.map((p, idx) => (
          <tr key={`prod-${idx}`}>
            <td>{p.name}</td>
            <td>{p.categoryName}</td>
            <td>
              {showAmountWithFormatting(p.amount)} ({p.percentage}) / {p.repetitions}
            </td>
          </tr>
        ))}

        {/* Product total */}
        <tr className="table-secondary">
          <td><FormattedMessage id="total_merchandise_sales" /></td>
          <td></td>
          <td>{showAmountWithFormatting(data.productTotal)}</td>
        </tr>

        {/* Grand total */}
        <tr className="fw-bold table-success">
          <td className="fw-bold"><FormattedMessage id="grand_total" /></td>
          <td></td>
          <td className="fw-bold">{showAmountWithFormatting(data.grandTotal)}</td>
        </tr>

        {/* <tr className="fw-bold table-success">
          <td><FormattedMessage id="discount" /></td>
          <td></td>
          <td>{showAmountWithFormatting(data.totalDiscount)}</td>
        </tr>

        <tr className="sticky-row">
          <td className="fw-bold text-dark"><FormattedMessage id="total_paid_amount" /></td>
          <td></td>
          <td className="fw-bold text-dark">{showAmountWithFormatting(data.totalPaidAmount)}</td>
          {data.treatments.length === 0  && paymentKeys.map((pm) => (
              <td
                key={pm}
                rowSpan={totalRows}
                className="align-middle fw-bold text-dark text-center"
              >
                {showAmountWithFormatting(data.payments[pm])}
              </td>
              )
            )}
        </tr> */}

      </tbody>
    </table>
    </div>
  );
};

export default DailyTotallingTable;
